module.exports = __webpack_public_path__ + "img/ltkfindsunder50-4x.845c08b.jpg";